<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      :showGoBack="true"
      :title="'Profile'"
    />

    <main
      class="scrollable container"
      :style="{paddingTop: '10%'}"
    >
      <img
        alt="avatar"
        src="https://george-fx.github.io/apitex_api/assets/users/01.png"
        :style="{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          margin: '0px auto',
          marginBottom: '14px',
        }"
      />
      <h4
        :style="{
          textAlign: 'center',
          color: 'var(--main-dark)',
          marginBottom: '4px',
          textTransform: 'capitalize',
        }"
      >
        Briley Henderson
      </h4>
      <span
        class="t16"
        :style="{textAlign: 'center', display: 'block', marginBottom: '30px'}"
        >+17 123 456 7890</span
      >
      <ul>
        <li
          v-for="(item, index) in profileItems"
          :key="item.id"
          :style="{
            gap: '10px',
            padding: '10px',
            borderRadius: '10px',
            backgroundColor: '#FFF7F2',
            marginBottom: index === profileItems.length - 1 ? '30px' : '8px',
          }"
          :class="{'row-center': true, clickable: item.goTo}"
          @click="item.goTo && $router.push(item.goTo)"
        >
          <component :is="item.icon" />
          <h5 :style="{marginRight: 'auto'}">
            {{ item.title }}
          </h5>
          <span
            class="t12"
            :style="{marginTop: '1px'}"
            v-if="item.title === 'Language'"
            >{{ selectedLanguage }}</span
          >
          <component
            v-if="item.goTo"
            :is="RightArrowSvg"
          />
          <component
            v-if="item.switcher"
            :is="Switcher"
          />
        </li>
      </ul>
      <Button
        title="Log Out"
        :colorSchema="'secondary'"
        @click="$router.push(routes.SIGN_IN)"
        :containerStyle="{marginBottom: '20px'}"
      />
    </main>
  </div>
</template>

<script setup>
// components
import {Header} from '@/components';
import {Button} from '@/components';
import {Switcher} from '@/components';

// svg
import {FaceIdSvg} from '@/assets/svg';
import {TranslateSvg} from '@/assets/svg';
import {RightArrowSvg} from '@/assets/svg';
import {ProfileUserSvg} from '@/assets/svg';
import {MessageCircleSvg} from '@/assets/svg';

// other
import {computed} from 'vue';
import {useStore} from 'vuex';
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

const store = useStore();
const opacity = useOpacity();

const selectedLanguage = computed(() => store.getters['language/language']);

const profileItems = [
  {
    id: 1,
    icon: ProfileUserSvg,
    title: 'Personal Info',
    goTo: routes.EDIT_PERSONAL_INFO,
    switcher: false,
  },
  {
    id: 2,
    icon: MessageCircleSvg,
    title: 'Notifications',
    goTo: '',
    switcher: true,
  },
  {
    id: 3,
    icon: FaceIdSvg,
    title: 'Face ID',
    goTo: '',
    switcher: true,
  },
  {
    id: 4,
    icon: TranslateSvg,
    title: 'Language',
    goTo: routes.SELECT_LANGUAGE,
    switcher: false,
  },
];
</script>
